import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const Images = ({ image, styleProp }) => {
  const data = useStaticQuery(graphql`
    query {
      doggreen: file(relativePath: { eq: "mockup/doggreen.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300, toFormat: WEBP) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      ladyyellow: file(relativePath: { eq: "mockup/ladyyellow.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300, toFormat: WEBP) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      shoesblue: file(relativePath: { eq: "mockup/shoesblue.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300, toFormat: WEBP) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      shoesred: file(relativePath: { eq: "mockup/shoesred.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300, toFormat: WEBP) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      shoesteal: file(relativePath: { eq: "mockup/shoesteal.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300, toFormat: WEBP) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      shoesyellow: file(relativePath: { eq: "mockup/shoesyellow.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300, toFormat: WEBP) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      smilinggirl: file(relativePath: { eq: "mockup/smilinggirl.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 540, toFormat: WEBP) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data[image].childImageSharp.fluid}
      alt={image}
      style={styleProp}
    />
  )
}

export default Images
